import { AnyAction, configureStore } from '@reduxjs/toolkit';
import { reducers } from './reducers';
import { preloadedState } from './preloadedState';

const reducerProxy = (state: any, action: AnyAction) => {
  if (action.type === 'logout/LOGOUT') {
    return reducers(undefined, action);
  }
  return reducers(state, action);
};

export const storeToolkit = configureStore({
  reducer: reducerProxy,
  preloadedState: {
    auth: {
      loading: false,
      ...preloadedState
    }
  },
  devTools: process.env.NODE_ENV === 'development'
});

export type AppDispatch = typeof storeToolkit.dispatch;
export type RootState = ReturnType<typeof storeToolkit.getState>;
